import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {ManufacturerApi} from "@app/manufacturer/shared/manufacturer.api";
import {Manufacturer} from "@app/manufacturer/shared/manufacturer";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {merge} from "rxjs";
import {tap} from "rxjs/operators";
import { FormControl, FormGroup, UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import {
  BaseDatasource,
  BaseList,
  pageSizeDefault,
  pageSizeOptions,
  Pagination,
  SearchFieldGroup,
  SearchOperator
} from "@shared/base";
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatSuffix, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatInput } from '@angular/material/input';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

@Component({
    templateUrl: './manufacturer-select-dialog.component.html',
    styleUrls: ['./manufacturer-select-dialog.component.scss'],
    imports: [MatToolbar, MatIconButton, MatSuffix, MatTooltip, MatIcon, CdkScrollable, MatDialogContent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, MatPaginator, MatButton]
})
export class ManufacturerSelectDialogComponent extends BaseList<Manufacturer> implements AfterViewInit {
  dialogRef = inject<MatDialogRef<ManufacturerSelectDialogComponent>>(MatDialogRef);
  protected listApi = inject(ManufacturerApi);
  protected listCachePrefix = 'device';

  title: string;
  dataSource: BaseDatasource<Manufacturer>;
  displayedColumns = ['name'];
  filterForm: FormGroup;
  searchField: boolean;

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('searchInput') searchInput!: ElementRef;

  constructor() {
    super();
    const data = inject(MAT_DIALOG_DATA);

    this.filterForm = new FormGroup({
      name: new FormControl<string | undefined>(undefined)
    });

    this.title = data.title;
    this.searchField = false;
  }

  defaultListForm(): UntypedFormGroup {
    return this.formBuilder.group({manufacturer: null});
  }

  defaultPagination(): Pagination {
    return new Pagination(0, pageSizeDefault, 'name', 'asc');
  }

  prepareSearch(values: Record<string, string>): SearchFieldGroup {
    const group: SearchFieldGroup = {
      type: 'AND',
      fields: [],
      groups: []
    };

    const properties = Object.keys(values);
    properties.forEach(value => {
      group.fields.push({
        fieldName: value,
        operator: SearchOperator.CONTAINS,
        value: values[value]
      });
    });

    return group;
  }

  ngAfterViewInit() {
    merge(this.sort.sortChange, this.paginator.page).pipe(
      tap(() => {
        this.loadData();
      })
    ).subscribe();

    this.loadData();
  }

  showSearch() {
    this.searchField = !this.searchField;

    //Otherwise the element isn't visible and the focus will not work
    setTimeout(()=>{
      this.searchInput.nativeElement.focus();
    }, 0);
  }

  select(manufacturer: Manufacturer) {
    this.dialogRef.close(manufacturer);
  }

  close() {
    this.dialogRef.close(true);
  }

  protected readonly pageSizeOptions = pageSizeOptions;
}
